@if (
  type !== "connections" ||
  (type === "connections" &&
    contactGroup &&
    contactGroup.contacts &&
    contactGroup.contacts.length)
) {
  <div>
    @if (title) {
      <div
        [ngClass]="{ top_margin: !noTopMargin }"
        class="header celo-cursor-pointer"
        data-testid="contact-group-toggle"
        (click)="loadContacts(); raiseAcordinActionEvents()"
      >
        <div class="title celo-elipsis">
          {{ title }}
          <span>
            @if (isWorkspaceVerified) {
              <app-badge
                class="inline-block"
                [clickable]="false"
                [isWorkspaceVerified]="true"
              ></app-badge>
            }
          </span>
        </div>
        @if (!disableExpansion) {
          <div class="arrow">
            @if (!hidden) {
              <i class="material-icons-round">expand_less</i>
            }
            @if (hidden) {
              <i class="material-icons-round">chevron_right</i>
            }
          </div>
        }
      </div>
    }
    @if (!hidden) {
      <div class="content">
        @if (
          selectable &&
          contactGroup.contacts &&
          contactGroup.contacts.length &&
          (type !== "workspace" || page_type === "new_broadcast")
        ) {
          <mat-checkbox
            class="select-all"
            aria-label="Select all workspace users"
            (change)="groupAction($event.checked, contactGroup)"
            [checked]="
              contactGroup.state === 'checked' ||
              contactGroup.state === 'disabled'
            "
            [indeterminate]="contactGroup.state === 'indeterminate'"
            [disabled]="contactGroup.state === 'disabled'"
          >
            <span>Select All</span>
          </mat-checkbox>
        }
        @if (type === "workspace") {
          <div>
            @for (
              department of groupedLocalContactsDepartments;
              track department
            ) {
              <div>
                @if (selectable) {
                  <mat-checkbox
                    class="select-all"
                    [attr.aria-label]="
                      'Select all ' + department.departmentName
                    "
                    (change)="groupAction($event.checked, department)"
                    [checked]="
                      department.state === 'checked' ||
                      department.state === 'disabled'
                    "
                    [indeterminate]="department.state === 'indeterminate'"
                    [disabled]="department.state === 'disabled'"
                  >
                    <div>{{ department.departmentName }}</div>
                  </mat-checkbox>
                }
                @if (!selectable) {
                  <div class="select-all">
                    {{ department.departmentName }}
                  </div>
                }
                <app-contact-list
                  [companyInFocus]="companyInFocus"
                  [companyInFocusId]="companyInFocusId"
                  [uneditableContactIds]="uneditableContactIds"
                  [isAddingParticipants]="isAddingParticipants"
                  [contactGroup]="department"
                  [type]="'workspace'"
                  [selectable]="selectable"
                  [userAccount]="userAccount"
                  [selectedContactsMap]="selectedContactsMap"
                  (contactClicked)="contactClicked.emit($event)"
                  (contactSelected)="contactSelected.emit($event)"
                  (remove)="remove.emit($event)"
                ></app-contact-list>
              </div>
            }
          </div>
        }
        @if (type === "connections") {
          <div>
            <app-contact-list
              [uneditableContactIds]="uneditableContactIds"
              [isAddingParticipants]="isAddingParticipants"
              [contactGroup]="contactGroup"
              [type]="'connections'"
              [selectable]="selectable"
              [userAccount]="userAccount"
              [selectedContactsMap]="selectedContactsMap"
              (contactClicked)="contactClicked.emit($event)"
              (contactSelected)="contactSelected.emit($event)"
              (remove)="remove.emit($event)"
            ></app-contact-list>
          </div>
        }
        @if (type === "suggestions") {
          <div>
            <app-contact-list
              [uneditableContactIds]="uneditableContactIds"
              [isAddingParticipants]="isAddingParticipants"
              [contactGroup]="contactGroup"
              [type]="'suggestions'"
              [selectable]="selectable"
              [userAccount]="userAccount"
              [selectedContactsMap]="selectedContactsMap"
              (contactClicked)="contactClicked.emit($event)"
              (contactSelected)="contactSelected.emit($event)"
              (remove)="remove.emit($event)"
            ></app-contact-list>
          </div>
        }
        @if (loading) {
          <div class="loading" data-testid="contact-group-loading">
            <app-empty-state
              [spinner]="true"
              [animation]="false"
              [isLoading]="true"
              [message]="' '"
              [diameter]="16"
              [stroke]="2"
            ></app-empty-state>
          </div>
        }
        @if (
          !loading &&
          page_type === "new_broadcast" &&
          !contactGroup.contacts.length
        ) {
          <div data-testid="contact-group-empty">No eligible users</div>
        }
      </div>
    }
  </div>
}
